import * as React from "react";
import styles from "./Bio.module.css";

export default function BioCard() {
  return (
    <section className={styles.bioSection}>
      <h2>About Me</h2>
      <p>
        Hello! My name is Matthew Leopold. I’m currently a senior at Boston
        College studying Computer Science (B.S.) and Biology (B.S.). I am
        interested in software development with a biological focus.
      </p>
      <p>
        If you would like to get in touch, <a href="mailto:contact@matt-leopold.com">email me</a>.
      </p>
    </section>
  );
}